var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLifeAndPeopleClothing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-2352.000000, -839.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Life-and-people/Clothing",
    transform: "translate(2352.000000, 839.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,14 C13,14.552 12.552,15 12,15 L10,15 C9.448,15 9,14.552 9,14 L9,11 L13,11 L13,14 Z M29.828,8.771 C27.327,5.654 23.996,3.307 20.219,2 C19.544,3.67 17.912,4.852 16,4.852 C14.087,4.852 12.456,3.67 11.781,2 C8.004,3.307 4.673,5.654 2.171,8.771 L0,11.477 L4,15 L7,12 L8,31 L20.205,31 C22.332,31 24.088,29.335 24.199,27.21 L25,12 L28,15 L32,11.477 L29.828,8.771 Z",
    id: 46
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifeAndPeopleClothing);
export default __webpack_public_path__ + "static/media/life-and-people-clothing.a55a9d4c.svg";
export { ForwardRef as ReactComponent };